import React, {Fragment} from "react";
import {Grid, GridItem, Title, TitleSizes} from "@patternfly/react-core";
import { QUERY_IMAGES } from "services/urls";

const ConfirmRegistration = () => {
    return (
        <Fragment>
            <Grid style={{
                margin : '2rem 0'
            }}>
                <GridItem>
                    <Title
                        style={{
                            textAlign : 'center'
                        }}
                        headingLevel={"h1"}
                        size={TitleSizes["2xl"]}
                    >
                        Bravo! La première étape d'inscription à la Banque à pitons a été effectuée.
                    </Title>
                </GridItem>
                <GridItem
                    style={{
                        textAlign : 'center'
                    }}
                >
                    <picture>
                        <img
                            sizes="(max-width: 1083px) 100vw, 1083px"
                            srcSet=
                                {QUERY_IMAGES + "img/44-layers_itxyud_c_scalew_1083.png"}
                            src={QUERY_IMAGES + "img/44-layers_itxyud_c_scalew_1083.png"}
                            alt="bravo"/>
                    </picture>
                </GridItem>
            </Grid>
        </Fragment>
    )
}

export default ConfirmRegistration;
